import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"solution-select","item-text":"nome","item-value":"municipioTarefaId","items":_vm.itens,"label":"Tarefa","clearable":"","placeholder":"Tarefa","return-object":true},on:{"change":_vm.change},model:{value:(_vm.filter.municipioTarefa),callback:function ($$v) {_vm.$set(_vm.filter, "municipioTarefa", $$v)},expression:"filter.municipioTarefa"}},[_c('template',{slot:"no-data"},[_vm._v("\n    Nenhuma Tarefa retornada\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }